__webpack_require__.p = "/react-2048/";